import React from 'react';
import cn from 'classnames';

import { navigate } from '@reach/router';
import { connect } from 'react-redux';

import isEmpty from 'lodash/isEmpty';

import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  root: {
    color: '#ffffff',
    border: '2px solid #6a27e8',
    background: '#6a27e8',
    textTransform: 'none',
    borderRadius: '16px',
    width: '86px',
    '&:hover': {
      border: '2px solid #6a27e8',
      background: '#ffffff',
      color: '#6a27e8',
    },
    [theme.breakpoints.down('sm')]: {
      marginTop: '8px',
      width: '200px',
      borderRadius: '26px',
    },
  },
  label: {
    fontFamily: 'Raleway',
    fontSize: '14px',
  },
});

const SignUpBtn = ({ classes, className, url = '/signup', hide }) => {
  const rootClassName = cn(classes.root, className);

  if (hide) return null;

  return (
    <Button
      variant="outlined"
      color="primary"
      className={rootClassName}
      onClick={() => navigate(url)}
      classes={{
        label: classes.label,
      }}
    >
      Sign up
    </Button>
  );
};

const mapStateToProps = state => ({
  hide: !isEmpty(state.user.userId),
});

export default connect(mapStateToProps)(withStyles(styles)(SignUpBtn));
